export enum TabIdEnum {
  MY_TICKETS = 'my-tickets',
  REDEMPTION = 'redemption',
}
